import { HttpClient } from '@angular/common/http';
import { AppService } from '../app.service';
import { ProductModel } from '../models/product.model';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ProductService extends AppService<ProductModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  private isCancelable = new Subject<boolean>();

  getIsCancelable(): Observable<boolean> {
    return this.isCancelable.asObservable();
  }

  setIsCancelable(): void {
    this.isCancelable.next(true);
  }

  setIsNotCancelable(): void {
    this.isCancelable.next(false);
  }

  async getAll(id: string) {
    const result = await this.getAllAsync(`Product/GetAll/${id}`);
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/product.service.ts